import { render } from "./settingsPage.vue?vue&type=template&id=118f5624"
import script from "./settingsPage.vue?vue&type=script&lang=js"
export * from "./settingsPage.vue?vue&type=script&lang=js"

import "./settingsPage.vue?vue&type=style&index=0&id=118f5624&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__